import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { FuseConfigService } from '@fuse/services/config';
import { AuthService } from 'app/core/auth/auth.service';
import { Observable, of, switchMap } from 'rxjs';


@Injectable({ providedIn: 'root' })
export class PaymentService {
    public options: object;
    public payload: object;
    public apiString: string;
    public subscriptionDetails: any;
    
    constructor(
        private _httpClient: HttpClient,
        private _fuseConfigService: FuseConfigService,
        private _authService: AuthService,
    ) {

      }
    
    public createPayment(payload: object): Observable<any>  {
        // ## NEED TO MAKE THE ENDPOINT GENERIC ##

        if(this._authService.getUserType() == "business"){
           this.apiString = 'business/internal/payment/create-payment';
        }else{
            this.apiString = 'visitor/brochure/voucher/create-payment';
        }
        return this._httpClient.post(this._fuseConfigService.global.settings["api_url"] + this.apiString, payload);
    }
    
    public dataToViewPayment(id: any): Observable<any>  {
        if(this._authService.getUserType() == "business"){
            this.apiString = 'business/internal/payment/data-to-view-payment';
         }else{
            this.apiString = 'visitor/brochure/voucher/data-to-view-payment'
         }
        let options = { params: { id: id } };
        return this._httpClient.get(this._fuseConfigService.global.settings["api_url"] + this.apiString , options);
    }

 
     
}
